import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import './assets/css/animate.css';
import './assets/css/custom_spacing.css';
import './App.css';
import Home from './components/Pages/Home';
import Layout from './components/Layout';
import { Provider } from 'react-redux';
import store from './redux/store';
import { PrivateRoute, PublicRoute } from './router/PrivateRoute';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from './utils/ScrollToTop';
import AppointmentDetails from './components/Pages/AppointmentDetails';
import { HelmetProvider } from 'react-helmet-async';

// Lazy-load non-home routes to improve initial load performance (especially on mobile).
const Login = lazy(() => import('./components/Auth/Login'));
const Register = lazy(() => import('./components/Auth/Register'));
const ForgotPassword = lazy(() => import('./components/Auth/ForgotPassword'));
const Dashboard = lazy(() => import('./components/Pages/Dashboard'));
const BookAppointment = lazy(() => import('./components/Pages/BookAppointment'));
const WhatWeTreat = lazy(() => import('./components/Pages/WhatWeTreat'));
const DataPrivacyEthics = lazy(() => import('./components/Pages/DataPrivacyEthics'));
const PoliciesProcedures = lazy(() => import('./components/Pages/PoliciesProcedures'));
const TermsOfUse = lazy(() => import('./components/Pages/TermsOfUse'));
const RefundPolicy = lazy(() => import('./components/Pages/RefundPolicy'));
const ContactUs = lazy(() => import('./components/Pages/ContactUs'));
const Appointments = lazy(() => import('./components/Pages/Appointments'));
const RescheduleAppointment = lazy(() => import('./components/Pages/RescheduleAppointment'));

function App({ setActiveTab }) {
  return (
    <HelmetProvider>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Provider store={store}>
        <Router>
          <ScrollToTop />
          <Layout>
            <Suspense fallback={null}>
              <Routes>
                <Route path="*" element={<Navigate to="/home" />} />
                <Route path="/" element={<Navigate to="/home" />} />
                <Route
                  path="/login"
                  element={<PublicRoute component={Login} />}
                />
                <Route
                  path="/register"
                  element={<PublicRoute component={Register} />}
                />
                <Route path="/dashboard/:tab?" element={<PrivateRoute component={Dashboard} />} />
                <Route path="/dashboard/appointment/:id" element={<AppointmentDetails setActiveTab={setActiveTab} />} />

                <Route path="/home" element={<Home />} />
                <Route path="/book-appointment" element={<BookAppointment />} />
                <Route path="/what-we-treat" element={<WhatWeTreat />} />
                <Route
                  path="/data-privacy-ethics"
                  element={<DataPrivacyEthics />}
                />
                <Route
                  path="/policies-procedures"
                  element={<PoliciesProcedures />}
                />
                <Route path="/terms-of-use" element={<TermsOfUse />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/appointments" element={<Appointments />} />
                <Route path="/reschedule/:id" element={<PrivateRoute component={RescheduleAppointment} />} />
                <Route path="/reschedule" element={<PrivateRoute component={RescheduleAppointment} />} />
              </Routes>
            </Suspense>
          </Layout>
        </Router>
      </Provider>
      <div className="scroll_btn">
        <span>
          <i className="fas fa-arrow-up"></i>
        </span>
      </div>
    </HelmetProvider>
  );
}

export default App;
